export default __webpack_public_path__ + "static/media/IMG_0375.311cd59c.jpg";